import {
  ContentBlock,
  DecisionStep,
  FactoryTypes,
  GuideContent,
  GuideTypes,
  Metadata,
} from "../models";
import { Entry } from "contentful";
import { convertToHtmlString, findContent } from "../utils";
import { FieldMapping, UserContextValues } from "../types";
import { getFactoryByType } from "./factoriesByType";
import { GuideContentWrappedWithFieldMapping } from "./GuideContentFactory";

export const createDecisionStep = (
  fieldMapping: FieldMapping<DecisionStep, FieldMapping<GuideContent>>,
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
  userContextValues?: UserContextValues,
): DecisionStep => {
  const questionText = findContent(
    entries,
    fieldMapping.questionText,
    guideType,
  );

  const yesButtonText = findContent(
    entries,
    fieldMapping.yesButtonText,
    guideType
  );

  const noButtonText = findContent(
    entries,
    fieldMapping.noButtonText,
    guideType
  );

  type DecisionStepInnerType = {
    type: FactoryTypes;
    fieldMapping: FieldMapping<GuideContent>;
  };

  const decisionStepData: Record<string, unknown> = {
    questionText: convertToHtmlString(
      questionText?.fields.richContent,
      userContextValues,
    ),
    yesButtonText: convertToHtmlString(
      yesButtonText?.fields.richContent,
      userContextValues
    ),
    noButtonText: convertToHtmlString(
      noButtonText?.fields.richContent,
      userContextValues
    ),
    buttonVariant: fieldMapping.buttonVariant
  };

  if(typeof fieldMapping.decisionOptions !== 'undefined'){
    decisionStepData.decisionOptions = (fieldMapping.decisionOptions as unknown as DecisionStep['decisionOptions'])?.map(
      ({ display, steps }) => ({
        display,
        steps: (steps as unknown as DecisionStepInnerType[]).map((step) => {
          const contentProcessed = getFactoryByType(step.type)(
            step.fieldMapping,
            entries,
            guideType,
            userContextValues,
          ) as GuideContent;
          if (typeof contentProcessed !== "undefined") {
            return { type: step.type, content: contentProcessed, fieldMapping: step.fieldMapping }
          }
        })
      })
    );
  }else{
    const yesSteps: GuideContentWrappedWithFieldMapping[] = [];
    (fieldMapping.yesSteps as unknown as DecisionStepInnerType[])?.forEach(
      ({ type, fieldMapping: stepFieldMapping }: DecisionStepInnerType) => {
        const contentProcessed = getFactoryByType(type)(
          stepFieldMapping,
          entries,
          guideType,
          userContextValues,
        ) as GuideContent;
        if (typeof contentProcessed !== "undefined") {
          yesSteps.push({ type, content: contentProcessed, fieldMapping: stepFieldMapping });
        }
      },
    );
    decisionStepData.yesSteps = yesSteps;
  
    const noSteps: GuideContentWrappedWithFieldMapping[] = [];
    (fieldMapping.noSteps as unknown as DecisionStepInnerType[])?.forEach(
      ({ type, fieldMapping: stepFieldMapping }: DecisionStepInnerType) => {
        const contentProcessed = getFactoryByType(type)(
          stepFieldMapping,
          entries,
          guideType,
          userContextValues,
        ) as GuideContent;
        if (typeof contentProcessed !== "undefined") {
          noSteps.push({ type, content: contentProcessed, fieldMapping: stepFieldMapping });
        }
      },
    );
    decisionStepData.noSteps = noSteps;
  }

  return decisionStepData;
};
